var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-scrollbar',{staticClass:"page"},[_vm._t("default",function(){return [_c('router-view',{key:_vm.$route.fullPath})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }